<template>
  <button class="button is-link" @click="triggerFileInput">
    <span class="icon is-small">
      <i class="fas fa-upload"></i>
    </span>
    <span>{{ buttonLabel }}</span>
    
    <input ref="fileInput" type="file"  class="is-hidden" accept="image/*" multiple @change="handleFiles" >
    <div class="notification popupStyle" style="display: inline-block;" v-if="uploadSpinner">
      <span class="uploadLoader" ></span>
      <p style="display: inline-block;">Converting an image...</p>
    </div>
  </button>
</template>

<script>
import { HeifDecoder } from 'libheif-js';

export default {
  props: {
    currentCount: {
      type: Number,
      default: 0
    }
  },
  data(){
    return{
      uploadSpinner: false
    }
  },
  computed: {
    buttonLabel() {
      return "Upload"
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    
    async handleFiles(event) {
      const files = event.target.files;
      if (!files || files.length === 0) {
        return;
      }
      
      this.uploadSpinner = true;
      
      /** AB: crea ObjectURL, mettere come funzione separata? */
      /*
        const processedFiles = [];
      for (const file of files) {
        let fileToUpload = file;
        if (this.isHeic(file)) {          
          try {
            fileToUpload = await this.decodeHeic(file)
          } catch (error) {
            console.error('HEIC decoding error:', error)
            // Fallback alla conversione standard
          }
        } 
        processedFiles.push(URL.createObjectURL(fileToUpload))
      }
      */
      
      let listFiles = [];
      for (const file of files) {
        let f = await this.fileToBase64(file);
        listFiles.push(f);
      }
      
      this.uploadSpinner = false;
      this.$emit('files-uploaded', listFiles)
      event.target.value = null
    },
    
    fileToBase64: async function(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      });
    },
    
    isHeic(file) {
      return file.type.includes('heic') || 
      file.type.includes('heif') || 
      file.name.toLowerCase().endsWith('.heic') || 
      file.name.toLowerCase().endsWith('.heif')
    },
    
    async decodeHeic(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = async (e) => {
          try {
            const arrayBuffer = e.target.result
            const decoder = new HeifDecoder()
            const data = new Uint8Array(arrayBuffer)
            
            const image = decoder.decode(data)[0]
            if (!image) reject(new Error('No HEIC image found'))
            
            const width = image.get_width()
            const height = image.get_height()
            const canvas = document.createElement('canvas')
            canvas.width = width
            canvas.height = height
            const ctx = canvas.getContext('2d')
            
            const imageData = await new Promise((innerResolve, innerReject) => {
              image.display({
                data: new Uint8ClampedArray(width * height * 4),
                width,
                height
              }, (displayData) => {
                if (!displayData) innerReject(new Error('HEIC decoding failed'))
                innerResolve(displayData)
              })
            })
            
            const imgData = new ImageData(imageData.data, width, height)
            ctx.putImageData(imgData, 0, 0)
            
            canvas.toBlob(blob => {
              resolve(URL.createObjectURL(blob))
            }, 'image/jpeg', 0.85)
          } catch (error) {
            reject(error)
          }
        }
        reader.readAsArrayBuffer(file)
      })
    }
  },
  
  beforeUnmount() {
    // Pulizia degli URL creati
    Object.values(this.processedFiles).forEach(url => {
      if (url.startsWith('blob:')) URL.revokeObjectURL(url)
    })
  }
}
</script>


<style scoped>
.buttons {
  margin: 0.5rem 0;
}

.is-hidden {
  opacity: 0;
  position: absolute;
  z-index: -1;
}


.button span:not(:last-child) {
  margin-right: 0.5em;
}

.popupStyle {
  padding:1.2vw 4vw 1vw 1vw;
  /* padding-top: 2%; */
  width:auto;
  position: fixed;
  top: 25px;
  right: 5%;
  min-width: 20%;
  z-index: 1000;
  /* opacity: 0.8; */
}
.uploadLoader {
  position: absolute;
  left: 89%;
  top: 1vw;
  z-index: 150;
  width: 18px;
  height: 18px;
  border: 4px solid rgba(156, 156, 156, 0.815);;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
} 

</style> 